/*
 *
 * OperationCustomerInfo
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 04-Dec-2025
 */

import OperationCustomerInfo from './OperationCustomerInfoContainer'

export default OperationCustomerInfo
